import React, { useState, useEffect } from "react";
import axios from "axios";
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";
import Form from "./Form";
import Testimonials from './Testimonials';
import { useTranslation } from "react-i18next";




const ContactComponent = () => {
const { t } = useTranslation();

    return (
        <div className="backgroundImage">
            <div className="overlayBleuABlanc"></div>
            <div className="container containerBlanc">
                <div className="sectionCentrale contact">
                    <h3 className="ms-5 titre">Contact</h3>
                    <div className="row infosContact">
                        <div className="col-lg-4 col-12  pt-3 pt-lg-0 text-center">
                            <span className="iconContact">
                                <MdOutlinePhone />
                            </span>
                            <h5><a href="tel:581-928-3611" className="decoration-none">(581)-928-3611</a></h5>
                        </div>
                        <div className="col-lg-4  pt-3 pt-lg-0 col-12 text-center">
                            <span className="iconContact">
                                <MdOutlineEmail />
                            </span>
                            <h5><a href="mailto:sgarantducas@hotmail.ca" className="decoration-none">sgarantducas@hotmail.ca</a></h5>
                        </div>
                        <div className="col-lg-4  pt-3 pt-lg-0 col-12 text-center">
                            <span className="iconContact">
                                <FaLinkedinIn />
                            </span>
                            <h5><a href="https://www.linkedin.com/in/sgarantducas/" className="decoration-none">sgarantducas</a></h5>
                        </div>

                    </div>

                    <Form />
                    
                        <h3 className="ms-md-5 fs-2 ms-0 text-center testimonialsTitle">{t('testi')}</h3>
                        <Testimonials />
                  

                </div>
            </div>
        </div>
    )
}

export default ContactComponent;
